var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table'),_c('SharePayments',{staticClass:"my-3"}),_c('CombineMenus',{staticClass:"my-3"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }